/*
 * Yönetim paneli site bağlamı (çoklu site, 22.10.2026; backend services/sites.py).
 *
 * BinoGaming ortak altyapıdır; panelde yönetilen iki halka açık site vardır:
 * BETRUN ve WINBINO. Seçim tarayıcıda saklanır (sayfa yenilense de aynı site
 * açılır) ve her `/admin/...` isteğine `X-Admin-Site` başlığıyla gider.
 * Yetki sunucudadır: yöneticinin yetkisi olmayan site 403 alır; seçici
 * sunucunun bildirdiği izinli siteleri gösterir.
 */
export const ADMIN_SITE_KEY = 'bhs_admin_site';
export const SITE_IDS = ['betrun', 'winbino'];
export const SITE_HEADER = 'X-Admin-Site';

export const readAdminSite = () => {
  try {
    const value = localStorage.getItem(ADMIN_SITE_KEY) || '';
    return SITE_IDS.includes(value) ? value : '';
  } catch {
    return '';
  }
};

export const storeAdminSite = (site) => {
  if (!SITE_IDS.includes(site)) return false;
  try {
    localStorage.setItem(ADMIN_SITE_KEY, site);
    return true;
  } catch {
    return false;
  }
};

export const clearAdminSite = () => {
  try { localStorage.removeItem(ADMIN_SITE_KEY); } catch { /* yok sayılır */ }
};

/** İstek yönetim ucuna mı gidiyor (başlık yalnız oraya eklenir). */
export const isAdminRequest = (url) => /^\/?admin\//.test(String(url || '').replace(/^https?:\/\/[^/]+\/api/, ''));

/**
 * Sunucunun site durumu ile yereldeki seçimi uzlaştırır: kayıtlı seçim yoksa ya
 * da artık izinli değilse sunucunun önerdiği site yazılır. Dönen değer etkin site.
 */
export const reconcileAdminSite = (state) => {
  const allowed = (state?.sites || []).filter((site) => site.allowed).map((site) => site.id);
  const stored = readAdminSite();
  if (stored && allowed.includes(stored)) return stored;
  const next = allowed.includes(state?.current) ? state.current : (allowed[0] || '');
  if (next) storeAdminSite(next); else clearAdminSite();
  return next;
};
